import dmi from './utils/deep-merge-inmutable';
import base from './base';
export default dmi(base, {
    message: {
        userActive: {
            dni: "Tarjeta de identidad",
            cuil: "Tarjeta de identidad",
            cuils: "Tarjetas de identidad",
            module_license: "Usa módulo de vacaciones y ausentismos",
            license_use_module: "Usa módulo de vacaciones y ausentismos",
        },
        label: {
            dni: "Tarjeta de identidad",
        },
        ei_titleList_text_1_3: "Tarjeta de identidad *",
        ei_titleList_text_1_4: "Tarjeta de identidad",
        ei_titleList_text_3_4: "Departamento",
        ei_titleList_text_3_5: "Provincia",
        ei_titleList_text_3_6: "Municipio",
        head_text_table_search_3: "Tarjeta de identidad",
        employees_list_search_desc: "Para realizar una búsqueda puede ingresar el Nombre, Apellido, Tarjeta de identidad o Email del empleado en el campo de búsqueda o seleccionar una combinación de filtros.",
        search_text_1_1: "Tarjeta de identidad, Nombre, Apellido o Email",
        menu_3: "Vacaciones y Ausentismos",
        menu_8: "Vacaciones y Ausentismos",
        menu_3_1: "Gestión de Vacaciones y Ausentismos",
        uploadImageComponent: {
            body: {
                leftContainer: {
                    filter: {
                        cuil: "Tarjeta de identidad",
                    }
                },
                noContentEmployeeInfo: {
                    noCuil: "No posee Tarjeta de identidad",
                }
            },
            errorLogs: {
                "05115": "La Tarjeta de identidad es requerida",
                "05121": "La Tarjeta de identidad debe contener entre 5 y 15 caracteres alfanuméricos, los caracteres alfanuméricos deben estar en mayúsculas",
                "05127": "La Tarjeta de identidad es duplicada",
            },
        },
        crossSelling: {
            licenses: {
                item_1: "Los empleados podrán solicitar vía mobile o desktop vacaciones y ausentismos",
            },
            toaster: {
                title: "Vacaciones y Ausentismos",
            }
        },
        publishDocuments: {
            configIndivualPublish: {
                inputCuil: {
                    label: "Identificador",
                    question: "¿Cuál es el Identificador del colaborador?",
                    description: "Ingresa el Identificador del colaborador al que quieres enviarle un documento"
                },
            }
        },
        certificates: {
            newCertificate: {
                personalInfo: {
                    dni: "Documento",
                },
                dni: "Documento"
            }
        },
        documentDetail: {
            commons: {
                cuil: "Tarjeta de identidad",
            }
        }
    }
})